module.exports = __webpack_public_path__ + "static/desktop-7891ccb27d7bf6b322f8254e2b47c6e4.webp";